"use client";

import "@/assets/css/pages/accessories.css";
import "@/assets/css/pages/tools.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/grid";

import Link from "next/link";
import CommonSwiper from "@/components/common/shared/Slider";
import { Grid, Navigation, Pagination } from "swiper/modules";
import ImageWithFallback from "@/components/common/ImageWithFallback";
import SwiperButton from "@/components/common/shared/Button/SwiperButton";

const ChildCategories = ({ category, imageType, items = [] }) => {
  const sliderConfig = {
    breakpoints: {
      0: {
        spaceBetween: 8,
        freeMode: true,
        slidesPerView: 3,
        grid: { rows: 2, fill: "row" },
      },
      767: {
        spaceBetween: 12,
        slidesPerView: 4,
        grid: { rows: 1, fill: "row" },
      },
      992: {
        spaceBetween: 12,
        slidesPerView: 5,
        grid: { rows: 1, fill: "row" },
      },
      1280: {
        spaceBetween: 12,
        slidesPerView: 6,
        grid: { rows: 1, fill: "row" },
      },
      1400: {
        spaceBetween: 12,
        slidesPerView: 7,
        grid: { rows: 1, fill: "row" },
      },
    },
    navigation: {
      prevEl: ".swiper-button-prev-season",
      nextEl: ".swiper-button-next-season",
    },
    pagination: {
      clickable: true,
    },
    modules: [Navigation, Pagination, Grid],
    speed: 300,
  };

  const slides = items.map?.((subCat) => {
    const linkUrl = subCat?.url_path.startsWith("/")
      ? subCat?.url_path
      : `/${subCat?.url_path}`;
    return {
      content: (
        <Link
          href={linkUrl}
          prefetch={false}
          className="flex h-full"
          key={`${subCat.id}-${subCat.name}`}
        >
          <div className="w-12/12 py-2 xs:px-12 px-[6px] border xs:hover:border-primary-black-700 border-primary-black-50 rounded-xl bg-tertiary-white flex flex-col justify-between">
            <div className="w-full xs:h-[132px] flex items-center xs:order-1 order-2">
              <ImageWithFallback
                width={141}
                height={132}
                type={imageType}
                key={subCat?.id}
                alt={subCat.name}
                src={subCat.image}
                className="w-full max-w-full xs:h-[132px] h-[74px] object-contain"
              />
            </div>
            <p className="xl:text-subtitle-3 xs:text-body-text-2-sb text-minor-text-1-b text-center xs:mt-1 xs:mb-0 mb-1 xs:order-2 order-1">
              {subCat.name}
            </p>
          </div>
        </Link>
      ),
    };
  });

  return (
    <section className="additive-section">
      <div className="container">
        <div className="row">
          <div className="col xs:min-h-[266px] min-h-[163px]">
            <h1 className="lg:text-headline-3 xs:text-headline-4 text-body-text-1-b xs:pb-24 pb-12 mb-0 lg:min-h-[68px] xs:min-h-[56px] min-h-[38px]">
              {category}
            </h1>

            {/* desktop UI */}
            <div className="relative mb-2">
              <div className="xs:block hidden">
                <SwiperButton prev className="swiper-button-prev-season" />
                <SwiperButton next className="swiper-button-next-season" />
              </div>
              <CommonSwiper
                slides={slides}
                config={sliderConfig}
                className="customAccessoriestSlider"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChildCategories;
